// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6g3cW","simple":"Button_simple__Qxtdd"};